<template>
  <div id="job-type-services">
    <div class="row">
      <div class="col-xs-12">
        <div class="shadow clearfix">
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="description" class="form-label">Description</label>
              <input type="text" class="form-control" id="description" v-model="jobTypeService.description"/>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="seq" class="form-label">Sequence</label>
              <input type="number" min="0" class="form-control" id="seq" v-model="jobTypeService.sequence"/>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label class="form-label" for="basic-details-sc">Service Class</label>
              <select v-model="jobTypeService.serviceType" id="basic-details-sc" class="form-control">
                <option value=""></option>
                <option v-for="option in $store.getters['systemOption/serviceTypes']" :value="option.id">{{ option.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12">
            <hr>
            <div class="pull-right">
              <div class="btn btn-success" @click="save">
                {{ saveOrUpdate }}
              </div>
              <div class="btn btn-danger" @click="clear">
                Clear
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-table
      :tableData="jobTypeServices"
      tableTitle="Services"
      v-on:table-edit-request="edit"
      :showEdit="true"
      v-on:table-delete-request="remove"
      :showDelete="true"
      :fields="fields"
    ></vue-table>
  </div>
</template>
<script>
  import VueTable from '../../../helpers/VueTable'
  import API from '../../../../api/endpoints'
  export default {
    name: 'JobTypeService',
    components: { VueTable },
    props: {
      jobType: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        jobTypeServices: [],
        fields: [
          { header: 'Description', prop: item => item.description },
          { header: 'Sequence', prop: item => item.sequence, numericalField: true }
        ],
        jobTypeService: {
          id: null,
          jobType: this.jobType,
          serviceType: null,
          description: null,
          sequence: 0
        }
      }
    },
    computed: {
      saveOrUpdate () {
        return this.jobTypeService.id ? 'Update' : 'Save'
      }
    },
    methods: {
      loadJobTypeServices () {
        this.$http.get(API.GET_ENTITIES('job-type-service'), {
          params: { jobType: this.jobType },
          headers: { 'X-Order-By': 'sequence' }
        })
          .then(({data}) => { this.jobTypeServices = data })
          .catch(console.log)
      },
      clear () {
        this.jobTypeService = {
          id: null,
          jobType: this.jobType,
          serviceType: null,
          description: null,
          sequence: 0
        }
        const arr = this.jobTypeServices.slice(0)
        const ret = arr.sort((a, b) => {
          return a.sequence - b.sequence
        })
        this.jobTypeServices = ret
      },
      remove ({ item }) {
        if (item && item.id) {
          this.$http.delete(API.DELETE_ADMIN_ENTITY('job-type-service', item.id))
            .then(() => {
              const i = this.jobTypeServices.findIndex(({id}) => id === item.id)
              if (i > -1) {
                this.jobTypeServices.splice(i, 1)
                this.clear()
              }
            }).catch(console.log)
        }
      },
      save () {
        const item = { ...this.jobTypeService }
        const url = item.id ? API.UPDATE_ADMIN_ENTITY('job-type-service', item.id)
          : API.CREATE_ADMIN_ENTITY('job-type-service')
        const method = item.id ? 'put' : 'post'
        this.$http[method](url, item)
          .then(({data}) => {
            if (method === 'post') {
              this.jobTypeServices.push(data)
            } else {
              const i = this.jobTypeServices.findIndex(({id}) => id === item.id)
              if (i > -1) {
                const found = this.jobTypeServices[i]
                for (let prop in data) {
                  found[prop] = data[prop]
                }
              }
            }
            this.clear()
          })
      },
      edit ({ item }) {
        this.jobTypeService = {
          id: item.id,
          jobType: item.jobType,
          serviceType: item.serviceType && item.serviceType.id,
          description: item.description,
          sequence: item.sequence
        }
      }
    },
    mounted () {
      this.loadJobTypeServices()
    }
  }
</script>



// WEBPACK FOOTER //
// JobTypeService.vue?230c5909